module.exports = __webpack_public_path__ + "img/oval-oval-oval-mask.47ff50cf.svg";